import React, { FC } from 'react';
import { InvoiceReminder } from '../../invoices.model';
import { EditIconBlue } from 'assets/icons';
import { formatReminderText } from 'containers/settings/utils';
import { transformInvoiceApiRemindersToComponentFormat } from '../../create-invoice/util';
import { ReminderDateTypeLabel } from 'containers/settings/constants';
import If from 'components/If/If';

interface InvoiceReminderDetailProps {
  reminders: InvoiceReminder[];
  isEditAllowed: boolean;
  onEditClick: () => void;
}

const InvoiceReminderDetail: FC<InvoiceReminderDetailProps> = ({ reminders, isEditAllowed, onEditClick }) => {
  const visibleReminders = reminders?.slice(0, 2);
  const remainingCount = reminders?.length - 2;

  const reminderConfigs = transformInvoiceApiRemindersToComponentFormat(visibleReminders);

  return (
    <div className="rounded-md bg-white shadow-section">
      <div className="px-5 py-3 text-17px font-bold text-headingGray">{`Payment reminders (${
        reminders?.length ?? 0
      })`}</div>
      <div className="px-5 pt-2 pb-4">
        <div className="flex items-start justify-between rounded-md border border-borderGray px-[13px] py-[15px]">
          <div className="text-sbase font-semibold text-primaryText">
            {reminderConfigs?.map((reminderConfig, index) => (
              <span key={reminderConfig.id || index}>
                {formatReminderText(reminderConfig, ReminderDateTypeLabel.DUE_DATE, false)}
                {index < reminderConfigs.length - 1 && ' , '}
              </span>
            ))}
            <If condition={remainingCount > 0}>
              <span className="text-primaryBtn"> ...+{remainingCount}</span>
            </If>
            <If condition={reminderConfigs.length === 0}>
              <span className="text-accentText">No reminders configured</span>
            </If>
          </div>
          <If condition={isEditAllowed}>
            <EditIconBlue
              className="h-[18px] w-[18px] shrink-0 cursor-pointer"
              onClick={onEditClick}
              role="presentation"
            />
          </If>
        </div>
      </div>
    </div>
  );
};

export default InvoiceReminderDetail;
